import { Component, OnInit } from "@angular/core";
import { RestService } from "../common/rest.service";
import { Router } from "@angular/router";
import { Project } from "../manage-project/manage-project.component";
import { ApplicationData } from "../manage-applications/manage-applications.component";
import { appConfigDetails } from "./constants/applicationsConfig";
import { ToastrService } from "ngx-toastr";
import { commonConstants } from "../common/constants/constants";
import { HttpErrorResponse } from "@angular/common/http";
import { NgxSpinnerService } from "ngx-spinner";
import { CookieService } from "ngx-cookie-service";
import { AuthService } from "../auth.service";

export interface UserProject {
  role: string;
  departmentName: string;
  detail: Project;
}

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
  appPanelAccess = false;
  projectPanelAccess = false;
  summaryAccess = false;
  projects: UserProject[];
  applications: ApplicationData[];
  applicationSummary: any;
  appUrls = appConfigDetails.appUrls;
  mobileApps = appConfigDetails.mobileApps;
  loginMsg = commonConstants.loginErrorMsg;

  constructor(
    private router: Router,
    private restService: RestService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private cookie: CookieService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.spinner.show();
    const fetchCount = Number(
      sessionStorage.getItem("projectAppsFetchCount") || "0"
    );

    this.restService.getProjectsApps().subscribe(
      (data) => {
        if (
          fetchCount < 1 &&
          data.message ===
            "There is no application/project active for current user"
        ) {
          {
            this.toastr.warning(
              "New User: For access request under Request Access tab",
              "Access Required"
            );
            this.router.navigate(["/addUser"]);
            sessionStorage.setItem("projectAppsFetchCount", "1");
            this.spinner.hide();
            return;
          }
        } else {
          this.spinner.hide();
        }

        if (data.response !== null) {
          this.projects = data.response.userProjects;
          this.applications = data.response.applications;
          this.applicationSummary = data.response.applications;

          this.sortApplications();
          if (this.projects.length > 0) {
            this.projectPanelAccess = true;
            sessionStorage.removeItem("projectAppsFetchCount");
          }
          if (this.applications.length > 0) {
            this.appPanelAccess = true;
          } else {
            this.summaryAccess = true;
          }
        } else {
          this.spinner.hide();
        }
      },
      (error) => {
        this.spinner.hide();
        if (typeof error.error.error !== "undefined") {
          if (error.error.error === "Unauthorized") {
            console.log(error.error.error);
          } else {
            console.log(error.error.error);
          }
        }

        if (
          fetchCount < 1 &&
          error.status === 400 &&
          error.error.details === "Validation Failed"
        ) {
          this.toastr.warning(
            "New User: For access request under Request Access tab",
            "Access Required"
          );
          this.router.navigate(["/addUser"]);
          sessionStorage.setItem("projectAppsFetchCount", "1");
          this.spinner.hide();
        }

        if (error instanceof HttpErrorResponse) {
          console.log(error.error.error);
        }
      }
    );
  }

  sortApplications(): void {
    this.applications.sort((a, b) => {
      const isMobileA = this.mobileApps[a.name] ? 1 : 0;
      const isMobileB = this.mobileApps[b.name] ? 1 : 0;

      // Sort by mobile apps first
      if (isMobileA !== isMobileB) {
        return isMobileB - isMobileA;
      }

      // If both are mobile or both are not mobile, sort by name
      return a.name.localeCompare(b.name);
    });
  }
}
